import { Component, inject, input } from '@angular/core';
import { LanguageSelectionComponent } from '../../../common/language-selection/language-selection.component';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { SocialMediaLinksComponent } from '../../../common/social-media-links/social-media-links.component';
import { NavbarService } from '../../../../services/navbar.service';
import { DOMHandlerService } from '../../../../services/domhandler.service';
import { NavbarItem } from '../../../../types/navbar.types';
import { NgClass } from '@angular/common';
import { SlugService } from '../../../../services/slug.service';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '../../../../services/language.service';

@Component({
    selector: 'app-navbar-items',
    imports: [
        LanguageSelectionComponent,
        RouterLink,
        NgClass,
        TranslatePipe,
        SocialMediaLinksComponent,
    ],
    templateUrl: './navbar-items.component.html',
})
export class NavbarItemsComponent {
    navbarItems = input.required<NavbarItem[]>();
    page = input.required<'hof' | 'apartment'>();
    navbarService = inject(NavbarService);
    domHandler = inject(DOMHandlerService);
    slugService = inject(SlugService);
    languageService = inject(LanguageService);
    private router = inject(Router);

    constructor() {
        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                this.domHandler.closeCollapse('hs-navbar-example-collapse');
            }
        });
    }
}
